/**
 * Theme components settings for the application.
 * This includes font families, weights, and styles for various text elements.
 */
const components = {
  // MUI IconButton
  MuiIconButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.text.primary,
      }),
    },
  },

  // MUI Button
  MuiButton: {
    styleOverrides: {
      root: ({ theme }) => ({
        
      }),
      contained:({ theme }) => ({
          minHeight: '35px',
          minWidth: '105px',
          boxShadow:theme.shadows[3],

          '&:hover': {
            boxShadow: theme.shadows[5],
          },
        }),
        error: ({ theme }) => ({
          backgroundColor: theme.palette.error.main,
          color: theme.palette.error.contrastText,
          '&:hover': {
            backgroundColor: theme.palette.error.dark,
            boxShadow: '0px 0px 4px 2px rgba(255, 147, 147, 1)', 
          },
        }),

        outlined: ({ theme }) => ({
        minWidth: '35px',             
        minHeight: '35px',
        borderRadius: '4px',
        padding: '0px 0px',
        marginTop: '3px',
        marginLeft: '6px',
        marginRight: '6px',
        '&:hover': {
          boxShadow:theme.shadows[3],
        },
        '& .MuiSvgIcon-root': {
          //fontSize: '1.4rem',
        },
    }),
          template: ({ theme }) => ({
        padding: "0.375rem 1rem 0.3125rem 1rem",
        fontSize: "0.64rem",
        textTransform: "uppercase",
        verticalAlign: "bottom",
        border: 0,
        fontWeight: 500,
        lineHeight: 1.5,
        textAlign: "center",
        userSelect: "none",
        backgroundColor: "transparent",
        borderRadius: "0.25rem",
        transition:
          "color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out",
      }),
      hamburger: ({ theme }) => ({
        minWidth: 0,
        width: 29,
        height: 29,
        borderRadius: "4px",
        borderWidth: "thin",
        borderStyle: "solid",
        borderColor: theme.palette.divider,
        backgroundColor: "transparent",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: 0,
        boxShadow: "none",
        textTransform: "none",
        "&:hover": {
          borderColor: theme.palette.text.primary,
          backgroundColor: theme.palette.action.hover,
          boxShadow: "none",
        },
        // icon color inside
        "& .MuiSvgIcon-root": {
          color: theme.palette.text.secondary,
          fontSize: "1.25rem",
        },
      }),
    },
  },



};

export default components;